/**
 * scale the asset to the middle of the canvas.
 * @param {Object} options
 * @param {Number} options.scale the new scale value.
 * @param {Number} options.oldScale the old scale value.
 * @param {AssetPosition} options.layout the location of the asset in the canvas area.
 * @param {AspectRatio} options.asset the asset aspect ratio.
 * @param {AspectRatio} options.canvas the canvas aspect ratio.
 * @param {Object} options.cropValues the current scale, offset.left and offset.top.
 */
export const changeScale = ({
  scale,
  oldScale,
  layout,
  asset,
  canvas,
  cropValues,
}) => {
  if (!scale || !cropValues) {
    return cropValues.offset;
  }
  const originalRatio = asset.width / asset.height;
  const canvasRatio = canvas.width / canvas.height;
  const widthInScale =
    originalRatio < canvasRatio
      ? (asset.width / asset.height) * (canvas.height / canvas.width)
      : 1;
  const heightInScale =
    originalRatio > canvasRatio
      ? (asset.width / asset.height) * (canvas.width / canvas.height)
      : 1;
  if (!oldScale) {
    oldScale = scale;
  }
  scale = Number(scale);
  oldScale = Number(oldScale);
  const cropGap = scale - oldScale;
  return {
    top:
      cropValues.offset.top +
      ((-cropGap * (-cropValues.offset.top + 0.5)) /
        (heightInScale * oldScale)) *
        heightInScale,
    left:
      cropValues.offset.left +
      ((-cropGap * (-cropValues.offset.left + 0.5)) /
        (widthInScale * oldScale)) *
        widthInScale,
  };
};

export const aspectRatioGap = (
  { top, left, right, bottom, zIndex },
  aspectRatioGap,
  baseAspectRatio = 16 / 9
) => {
  const gap = (baseAspectRatio - aspectRatioGap) / (2 * baseAspectRatio);
  right = right * (aspectRatioGap / baseAspectRatio) + gap;
  left = (left * aspectRatioGap) / baseAspectRatio + gap;
  return { top, left, right, bottom, zIndex };
};
